module.exports = __webpack_public_path__ + "static/media/feuerleoscher_aktiv.c95b564c.png";